module.exports = __webpack_public_path__ + "static/media/logo.1ae7635e.png";